var map = {
	"./af/analysis.json": [
		65141,
		65141
	],
	"./af/auth.json": [
		45213,
		45213
	],
	"./af/common.json": [
		51301,
		51301
	],
	"./af/emailActivation.json": [
		94665,
		94665
	],
	"./af/gameReview.json": [
		98264,
		98264
	],
	"./af/home.json": [
		42460,
		42460
	],
	"./af/lobby.json": [
		43893,
		43893
	],
	"./af/puzzles.json": [
		51052,
		51052
	],
	"./ar/analysis.json": [
		48354,
		48354
	],
	"./ar/auth.json": [
		261,
		261
	],
	"./ar/common.json": [
		11111,
		11111
	],
	"./ar/emailActivation.json": [
		11933,
		11933
	],
	"./ar/gameReview.json": [
		77982,
		77982
	],
	"./ar/home.json": [
		50609,
		50609
	],
	"./ar/lobby.json": [
		7236,
		7236
	],
	"./ar/puzzles.json": [
		40587,
		40587
	],
	"./az/analysis.json": [
		74477,
		74477
	],
	"./az/auth.json": [
		87134,
		87134
	],
	"./az/common.json": [
		69579,
		69579
	],
	"./az/emailActivation.json": [
		10779,
		10779
	],
	"./az/gameReview.json": [
		86005,
		86005
	],
	"./az/home.json": [
		35017,
		35017
	],
	"./az/lobby.json": [
		80002,
		80002
	],
	"./az/puzzles.json": [
		533,
		533
	],
	"./be/analysis.json": [
		14601,
		27793
	],
	"./be/auth.json": [
		11000,
		11000
	],
	"./be/common.json": [
		68714,
		68714
	],
	"./be/emailActivation.json": [
		36873,
		36873
	],
	"./be/gameReview.json": [
		70322,
		70322
	],
	"./be/home.json": [
		44609,
		44609
	],
	"./be/lobby.json": [
		70995,
		70995
	],
	"./be/puzzles.json": [
		51444,
		51444
	],
	"./bg/analysis.json": [
		90178,
		90178
	],
	"./bg/auth.json": [
		20959,
		20959
	],
	"./bg/common.json": [
		26564,
		26564
	],
	"./bg/emailActivation.json": [
		2230,
		2230
	],
	"./bg/gameReview.json": [
		20110,
		20110
	],
	"./bg/home.json": [
		87025,
		87025
	],
	"./bg/lobby.json": [
		6009,
		6009
	],
	"./bg/puzzles.json": [
		43668,
		43668
	],
	"./bn/analysis.json": [
		63022,
		63022
	],
	"./bn/auth.json": [
		70530,
		70530
	],
	"./bn/common.json": [
		50371,
		50371
	],
	"./bn/emailActivation.json": [
		64481,
		61582
	],
	"./bn/gameReview.json": [
		71853,
		71853
	],
	"./bn/home.json": [
		82481,
		82481
	],
	"./bn/lobby.json": [
		64102,
		64102
	],
	"./bn/puzzles.json": [
		15139,
		15139
	],
	"./bs/analysis.json": [
		80430,
		80430
	],
	"./bs/auth.json": [
		24695,
		24695
	],
	"./bs/common.json": [
		62752,
		62752
	],
	"./bs/emailActivation.json": [
		97235,
		97235
	],
	"./bs/gameReview.json": [
		83965,
		83965
	],
	"./bs/home.json": [
		82201,
		82201
	],
	"./bs/lobby.json": [
		17407,
		17407
	],
	"./bs/puzzles.json": [
		17935,
		17935
	],
	"./cs/analysis.json": [
		10983,
		10983
	],
	"./cs/auth.json": [
		90468,
		90468
	],
	"./cs/common.json": [
		38913,
		38913
	],
	"./cs/emailActivation.json": [
		88973,
		88973
	],
	"./cs/gameReview.json": [
		29190,
		29190
	],
	"./cs/home.json": [
		19786,
		19786
	],
	"./cs/lobby.json": [
		85036,
		85036
	],
	"./cs/puzzles.json": [
		30300,
		30300
	],
	"./da/analysis.json": [
		19953,
		19953
	],
	"./da/auth.json": [
		66918,
		66918
	],
	"./da/common.json": [
		7682,
		7682
	],
	"./da/emailActivation.json": [
		66572,
		66572
	],
	"./da/gameReview.json": [
		9178,
		82796
	],
	"./da/home.json": [
		52717,
		52717
	],
	"./da/lobby.json": [
		62449,
		62449
	],
	"./da/puzzles.json": [
		64225,
		64225
	],
	"./de/analysis.json": [
		64106,
		64106
	],
	"./de/auth.json": [
		67754,
		67754
	],
	"./de/common.json": [
		21545,
		21545
	],
	"./de/emailActivation.json": [
		21448,
		21448
	],
	"./de/gameReview.json": [
		63122,
		63122
	],
	"./de/home.json": [
		18948,
		18948
	],
	"./de/lobby.json": [
		55868,
		55868
	],
	"./de/puzzles.json": [
		67729,
		67729
	],
	"./el/analysis.json": [
		49839,
		49839
	],
	"./el/auth.json": [
		1615,
		1615
	],
	"./el/common.json": [
		3319,
		3319
	],
	"./el/emailActivation.json": [
		37524,
		37524
	],
	"./el/gameReview.json": [
		18503,
		18503
	],
	"./el/home.json": [
		70002,
		70002
	],
	"./el/lobby.json": [
		940,
		940
	],
	"./el/puzzles.json": [
		89300,
		89300
	],
	"./en-GB/analysis.json": [
		56466,
		56466
	],
	"./en-GB/auth.json": [
		22393,
		22393
	],
	"./en-GB/common.json": [
		48391,
		48391
	],
	"./en-GB/emailActivation.json": [
		50902,
		50902
	],
	"./en-GB/gameReview-ui.json": [
		26801,
		26801
	],
	"./en-GB/gameReview.json": [
		64150,
		64150
	],
	"./en-GB/home.json": [
		62703,
		62703
	],
	"./en-GB/lobby.json": [
		63174,
		63174
	],
	"./en-GB/puzzles.json": [
		4358,
		4358
	],
	"./en/analysis.json": [
		96306,
		96306
	],
	"./en/auth.json": [
		77542,
		77542
	],
	"./en/common.json": [
		40464,
		40464
	],
	"./en/emailActivation.json": [
		93832,
		93832
	],
	"./en/gameReview-ui.json": [
		30870,
		30870
	],
	"./en/gameReview.json": [
		67946,
		67946
	],
	"./en/home.json": [
		12482,
		12482
	],
	"./en/lobby.json": [
		64689,
		64689
	],
	"./en/puzzles.json": [
		13305,
		13305
	],
	"./es/analysis.json": [
		74336,
		74336
	],
	"./es/auth.json": [
		50746,
		50746
	],
	"./es/common.json": [
		10357,
		10357
	],
	"./es/emailActivation.json": [
		32866,
		32866
	],
	"./es/gameReview.json": [
		45059,
		45059
	],
	"./es/home.json": [
		76891,
		76891
	],
	"./es/lobby.json": [
		78748,
		78748
	],
	"./es/puzzles.json": [
		79193,
		79193
	],
	"./et/analysis.json": [
		80737,
		80737
	],
	"./et/auth.json": [
		28288,
		28288
	],
	"./et/common.json": [
		61646,
		61646
	],
	"./et/emailActivation.json": [
		16813,
		16813
	],
	"./et/gameReview.json": [
		42353,
		42353
	],
	"./et/home.json": [
		8994,
		8994
	],
	"./et/lobby.json": [
		76461,
		76461
	],
	"./et/puzzles.json": [
		47176,
		47176
	],
	"./fa/analysis.json": [
		67744,
		67744
	],
	"./fa/auth.json": [
		30669,
		30669
	],
	"./fa/common.json": [
		70512,
		70512
	],
	"./fa/emailActivation.json": [
		63074,
		63074
	],
	"./fa/gameReview.json": [
		24443,
		24443
	],
	"./fa/home.json": [
		17859,
		17859
	],
	"./fa/lobby.json": [
		32156,
		32156
	],
	"./fa/puzzles.json": [
		67747,
		67747
	],
	"./fi/analysis.json": [
		74929,
		74929
	],
	"./fi/auth.json": [
		82159,
		82159
	],
	"./fi/common.json": [
		8418,
		8418
	],
	"./fi/emailActivation.json": [
		50807,
		50807
	],
	"./fi/gameReview.json": [
		4798,
		4798
	],
	"./fi/home.json": [
		32771,
		32771
	],
	"./fi/lobby.json": [
		60501,
		60501
	],
	"./fi/puzzles.json": [
		6449,
		6449
	],
	"./fr/analysis.json": [
		19977,
		19977
	],
	"./fr/auth.json": [
		46014,
		46014
	],
	"./fr/common.json": [
		45167,
		45167
	],
	"./fr/emailActivation.json": [
		22014,
		22014
	],
	"./fr/gameReview.json": [
		76298,
		76298
	],
	"./fr/home.json": [
		31660,
		31660
	],
	"./fr/lobby.json": [
		18853,
		18853
	],
	"./fr/puzzles.json": [
		51780,
		51780
	],
	"./he/analysis.json": [
		63633,
		63633
	],
	"./he/auth.json": [
		58268,
		58268
	],
	"./he/common.json": [
		15657,
		15657
	],
	"./he/emailActivation.json": [
		88153,
		88153
	],
	"./he/gameReview.json": [
		55516,
		55516
	],
	"./he/home.json": [
		41593,
		41593
	],
	"./he/lobby.json": [
		52009,
		52009
	],
	"./he/puzzles.json": [
		85516,
		85516
	],
	"./hi/analysis.json": [
		77362,
		77362
	],
	"./hi/auth.json": [
		56886,
		56886
	],
	"./hi/common.json": [
		26729,
		26729
	],
	"./hi/emailActivation.json": [
		69564,
		69564
	],
	"./hi/gameReview.json": [
		46466,
		46466
	],
	"./hi/home.json": [
		18945,
		18945
	],
	"./hi/lobby.json": [
		10123,
		10123
	],
	"./hi/puzzles.json": [
		9519,
		9519
	],
	"./hr/analysis.json": [
		76432,
		76432
	],
	"./hr/auth.json": [
		3914,
		3914
	],
	"./hr/common.json": [
		22146,
		22146
	],
	"./hr/emailActivation.json": [
		24837,
		24837
	],
	"./hr/gameReview.json": [
		91361,
		91361
	],
	"./hr/home.json": [
		73674,
		73674
	],
	"./hr/lobby.json": [
		98667,
		98667
	],
	"./hr/puzzles.json": [
		24037,
		24037
	],
	"./hu/analysis.json": [
		62965,
		62965
	],
	"./hu/auth.json": [
		30017,
		30017
	],
	"./hu/common.json": [
		85474,
		85474
	],
	"./hu/emailActivation.json": [
		13567,
		13567
	],
	"./hu/gameReview.json": [
		29300,
		94983
	],
	"./hu/home.json": [
		47352,
		47352
	],
	"./hu/lobby.json": [
		59612,
		59612
	],
	"./hu/puzzles.json": [
		51140,
		51140
	],
	"./hy/analysis.json": [
		78708,
		78708
	],
	"./hy/auth.json": [
		47579,
		47579
	],
	"./hy/common.json": [
		60160,
		60160
	],
	"./hy/emailActivation.json": [
		47474,
		47474
	],
	"./hy/gameReview.json": [
		49605,
		49605
	],
	"./hy/home.json": [
		33577,
		33577
	],
	"./hy/lobby.json": [
		6127,
		6127
	],
	"./hy/puzzles.json": [
		27673,
		27673
	],
	"./id/analysis.json": [
		95471,
		95471
	],
	"./id/auth.json": [
		4219,
		4219
	],
	"./id/common.json": [
		81610,
		81610
	],
	"./id/emailActivation.json": [
		88533,
		88533
	],
	"./id/gameReview.json": [
		49264,
		49264
	],
	"./id/home.json": [
		96903,
		96903
	],
	"./id/lobby.json": [
		63095,
		63095
	],
	"./id/puzzles.json": [
		76800,
		76800
	],
	"./is/analysis.json": [
		38655,
		38655
	],
	"./is/auth.json": [
		40544,
		40544
	],
	"./is/common.json": [
		53895,
		53895
	],
	"./is/emailActivation.json": [
		49961,
		49961
	],
	"./is/gameReview.json": [
		96240,
		96240
	],
	"./is/home.json": [
		34815,
		34815
	],
	"./is/lobby.json": [
		38420,
		38420
	],
	"./is/puzzles.json": [
		71475,
		71475
	],
	"./it/analysis.json": [
		24873,
		24873
	],
	"./it/auth.json": [
		25204,
		25204
	],
	"./it/common.json": [
		9486,
		9486
	],
	"./it/emailActivation.json": [
		9890,
		9890
	],
	"./it/gameReview.json": [
		93626,
		93626
	],
	"./it/home.json": [
		53765,
		53765
	],
	"./it/lobby.json": [
		38754,
		38754
	],
	"./it/puzzles.json": [
		34070,
		34070
	],
	"./ja/analysis.json": [
		44615,
		44615
	],
	"./ja/auth.json": [
		34975,
		34975
	],
	"./ja/common.json": [
		20459,
		20459
	],
	"./ja/emailActivation.json": [
		95367,
		95367
	],
	"./ja/gameReview.json": [
		49495,
		49495
	],
	"./ja/home.json": [
		68769,
		68769
	],
	"./ja/lobby.json": [
		889,
		889
	],
	"./ja/puzzles.json": [
		90621,
		90621
	],
	"./ka/analysis.json": [
		71108,
		71108
	],
	"./ka/auth.json": [
		43793,
		43793
	],
	"./ka/common.json": [
		6290,
		6290
	],
	"./ka/emailActivation.json": [
		61657,
		61657
	],
	"./ka/gameReview.json": [
		71350,
		71350
	],
	"./ka/home.json": [
		23273,
		23273
	],
	"./ka/lobby.json": [
		99986,
		99986
	],
	"./ka/puzzles.json": [
		47207,
		47207
	],
	"./kk/analysis.json": [
		47606,
		47606
	],
	"./kk/auth.json": [
		11971,
		11971
	],
	"./kk/common.json": [
		68316,
		68316
	],
	"./kk/emailActivation.json": [
		42121,
		42121
	],
	"./kk/gameReview.json": [
		4377,
		4377
	],
	"./kk/home.json": [
		89635,
		89635
	],
	"./kk/lobby.json": [
		97314,
		97314
	],
	"./kk/puzzles.json": [
		35664,
		35664
	],
	"./ko/analysis.json": [
		62710,
		62710
	],
	"./ko/auth.json": [
		71898,
		71898
	],
	"./ko/common.json": [
		95271,
		95271
	],
	"./ko/emailActivation.json": [
		41136,
		41136
	],
	"./ko/gameReview.json": [
		17633,
		17633
	],
	"./ko/home.json": [
		12853,
		12853
	],
	"./ko/lobby.json": [
		54977,
		54977
	],
	"./ko/puzzles.json": [
		16443,
		16443
	],
	"./lt/analysis.json": [
		16364,
		31226
	],
	"./lt/auth.json": [
		87443,
		87443
	],
	"./lt/common.json": [
		15064,
		15064
	],
	"./lt/emailActivation.json": [
		24504,
		24504
	],
	"./lt/gameReview.json": [
		89044,
		89044
	],
	"./lt/home.json": [
		33266,
		33266
	],
	"./lt/lobby.json": [
		88709,
		88709
	],
	"./lt/puzzles.json": [
		84162,
		84162
	],
	"./lv/analysis.json": [
		84025,
		75435
	],
	"./lv/auth.json": [
		99162,
		99162
	],
	"./lv/common.json": [
		95224,
		95224
	],
	"./lv/emailActivation.json": [
		5617,
		5617
	],
	"./lv/gameReview.json": [
		33143,
		33143
	],
	"./lv/home.json": [
		56681,
		56681
	],
	"./lv/lobby.json": [
		89192,
		89192
	],
	"./lv/puzzles.json": [
		88322,
		88322
	],
	"./ml/analysis.json": [
		54595,
		54595
	],
	"./ml/auth.json": [
		14520,
		14520
	],
	"./ml/common.json": [
		6091,
		6091
	],
	"./ml/emailActivation.json": [
		4202,
		4202
	],
	"./ml/gameReview.json": [
		99123,
		99123
	],
	"./ml/home.json": [
		98664,
		98664
	],
	"./ml/lobby.json": [
		91042,
		91042
	],
	"./ml/puzzles.json": [
		46608,
		46608
	],
	"./mn/analysis.json": [
		60423,
		60423
	],
	"./mn/auth.json": [
		3377,
		3377
	],
	"./mn/common.json": [
		20211,
		20211
	],
	"./mn/emailActivation.json": [
		51151,
		51151
	],
	"./mn/gameReview.json": [
		75506,
		75506
	],
	"./mn/home.json": [
		68493,
		68493
	],
	"./mn/lobby.json": [
		34644,
		34644
	],
	"./mn/puzzles.json": [
		81384,
		81384
	],
	"./nb/analysis.json": [
		54410,
		54410
	],
	"./nb/auth.json": [
		55116,
		55116
	],
	"./nb/common.json": [
		92530,
		92530
	],
	"./nb/emailActivation.json": [
		94181,
		94181
	],
	"./nb/gameReview.json": [
		22624,
		22624
	],
	"./nb/home.json": [
		55247,
		55247
	],
	"./nb/lobby.json": [
		77075,
		77075
	],
	"./nb/puzzles.json": [
		51437,
		51437
	],
	"./nl/analysis.json": [
		99108,
		99108
	],
	"./nl/auth.json": [
		67393,
		67393
	],
	"./nl/common.json": [
		1211,
		1211
	],
	"./nl/emailActivation.json": [
		34005,
		34005
	],
	"./nl/gameReview.json": [
		38639,
		38639
	],
	"./nl/home.json": [
		86385,
		86385
	],
	"./nl/lobby.json": [
		6071,
		6071
	],
	"./nl/puzzles.json": [
		44763,
		44763
	],
	"./pl/analysis.json": [
		80325,
		80325
	],
	"./pl/auth.json": [
		79236,
		79236
	],
	"./pl/common.json": [
		45878,
		45878
	],
	"./pl/emailActivation.json": [
		11534,
		11534
	],
	"./pl/gameReview.json": [
		68199,
		68199
	],
	"./pl/home.json": [
		8797,
		8797
	],
	"./pl/lobby.json": [
		72721,
		72721
	],
	"./pl/puzzles.json": [
		15779,
		15779
	],
	"./ps/analysis.json": [
		80833,
		80833
	],
	"./ps/auth.json": [
		17735,
		17735
	],
	"./ps/common.json": [
		36645,
		36645
	],
	"./ps/emailActivation.json": [
		61154,
		61154
	],
	"./ps/gameReview.json": [
		81080,
		81080
	],
	"./ps/home.json": [
		42278,
		42278
	],
	"./ps/lobby.json": [
		93210,
		93210
	],
	"./ps/puzzles.json": [
		18352,
		18352
	],
	"./pt-PT/analysis.json": [
		5113,
		5113
	],
	"./pt-PT/auth.json": [
		92477,
		92477
	],
	"./pt-PT/common.json": [
		17294,
		17294
	],
	"./pt-PT/emailActivation.json": [
		26792,
		26792
	],
	"./pt-PT/gameReview.json": [
		18609,
		18609
	],
	"./pt-PT/home.json": [
		71124,
		71124
	],
	"./pt-PT/lobby.json": [
		50785,
		50785
	],
	"./pt-PT/puzzles.json": [
		9904,
		9904
	],
	"./pt/analysis.json": [
		22077,
		22077
	],
	"./pt/auth.json": [
		69789,
		69789
	],
	"./pt/common.json": [
		41400,
		41400
	],
	"./pt/emailActivation.json": [
		24056,
		24056
	],
	"./pt/gameReview.json": [
		56687,
		56687
	],
	"./pt/home.json": [
		44766,
		44766
	],
	"./pt/lobby.json": [
		47090,
		365
	],
	"./pt/puzzles.json": [
		80346,
		80346
	],
	"./ro/analysis.json": [
		5066,
		5066
	],
	"./ro/auth.json": [
		39563,
		39563
	],
	"./ro/common.json": [
		4686,
		4686
	],
	"./ro/emailActivation.json": [
		18154,
		18154
	],
	"./ro/gameReview.json": [
		17643,
		17643
	],
	"./ro/home.json": [
		10153,
		10153
	],
	"./ro/lobby.json": [
		48909,
		48909
	],
	"./ro/puzzles.json": [
		60829,
		60829
	],
	"./ru/analysis.json": [
		39608,
		39608
	],
	"./ru/auth.json": [
		27356,
		22200
	],
	"./ru/common.json": [
		77247,
		77247
	],
	"./ru/emailActivation.json": [
		24410,
		24410
	],
	"./ru/gameReview.json": [
		61454,
		61454
	],
	"./ru/home.json": [
		32503,
		32503
	],
	"./ru/lobby.json": [
		68040,
		68040
	],
	"./ru/puzzles.json": [
		42231,
		42231
	],
	"./sk/analysis.json": [
		59036,
		59036
	],
	"./sk/auth.json": [
		59392,
		59392
	],
	"./sk/common.json": [
		25446,
		25446
	],
	"./sk/emailActivation.json": [
		53182,
		53182
	],
	"./sk/gameReview.json": [
		97809,
		97809
	],
	"./sk/home.json": [
		10238,
		10238
	],
	"./sk/lobby.json": [
		56625,
		56625
	],
	"./sk/puzzles.json": [
		25413,
		25413
	],
	"./sl/analysis.json": [
		18579,
		18579
	],
	"./sl/auth.json": [
		68909,
		68909
	],
	"./sl/common.json": [
		52068,
		52068
	],
	"./sl/emailActivation.json": [
		62056,
		62056
	],
	"./sl/gameReview.json": [
		6093,
		6093
	],
	"./sl/home.json": [
		58486,
		58486
	],
	"./sl/lobby.json": [
		85306,
		85306
	],
	"./sl/puzzles.json": [
		64468,
		64468
	],
	"./sr/analysis.json": [
		43957,
		43957
	],
	"./sr/auth.json": [
		32695,
		32695
	],
	"./sr/common.json": [
		13911,
		13911
	],
	"./sr/emailActivation.json": [
		24714,
		24714
	],
	"./sr/gameReview.json": [
		41607,
		41607
	],
	"./sr/home.json": [
		78793,
		78793
	],
	"./sr/lobby.json": [
		36836,
		36836
	],
	"./sr/puzzles.json": [
		36824,
		36824
	],
	"./sv/analysis.json": [
		60759,
		60759
	],
	"./sv/auth.json": [
		53140,
		53140
	],
	"./sv/common.json": [
		56504,
		56504
	],
	"./sv/emailActivation.json": [
		7546,
		7546
	],
	"./sv/gameReview-final.json": [
		565,
		565
	],
	"./sv/gameReview.json": [
		93784,
		93784
	],
	"./sv/home.json": [
		17099,
		17099
	],
	"./sv/lobby.json": [
		19892,
		19892
	],
	"./sv/puzzles.json": [
		43994,
		43994
	],
	"./sw/analysis.json": [
		72521,
		72521
	],
	"./sw/auth.json": [
		32944,
		32944
	],
	"./sw/common.json": [
		21124,
		21124
	],
	"./sw/emailActivation.json": [
		59780,
		59780
	],
	"./sw/gameReview.json": [
		12057,
		12057
	],
	"./sw/home.json": [
		28227,
		28227
	],
	"./sw/lobby.json": [
		60648,
		60648
	],
	"./sw/puzzles.json": [
		38843,
		38843
	],
	"./th/analysis.json": [
		78487,
		78487
	],
	"./th/auth.json": [
		96506,
		96506
	],
	"./th/common.json": [
		31550,
		63303
	],
	"./th/emailActivation.json": [
		424,
		424
	],
	"./th/gameReview.json": [
		19581,
		19581
	],
	"./th/home.json": [
		61686,
		61686
	],
	"./th/lobby.json": [
		31618,
		31618
	],
	"./th/puzzles.json": [
		42852,
		42852
	],
	"./tk/analysis.json": [
		87620,
		87620
	],
	"./tk/auth.json": [
		60023,
		60023
	],
	"./tk/common.json": [
		72923,
		72923
	],
	"./tk/emailActivation.json": [
		7452,
		7452
	],
	"./tk/gameReview.json": [
		64804,
		64804
	],
	"./tk/home.json": [
		57028,
		57028
	],
	"./tk/lobby.json": [
		46586,
		46586
	],
	"./tk/puzzles.json": [
		47065,
		47065
	],
	"./tr/analysis.json": [
		40237,
		40237
	],
	"./tr/auth.json": [
		30903,
		30903
	],
	"./tr/common.json": [
		72973,
		72973
	],
	"./tr/emailActivation.json": [
		36495,
		36495
	],
	"./tr/gameReview.json": [
		88472,
		88472
	],
	"./tr/home.json": [
		27646,
		27646
	],
	"./tr/lobby.json": [
		52050,
		52050
	],
	"./tr/puzzles.json": [
		45759,
		45759
	],
	"./uk/analysis.json": [
		54959,
		54959
	],
	"./uk/auth.json": [
		10017,
		10017
	],
	"./uk/common.json": [
		98783,
		98783
	],
	"./uk/emailActivation.json": [
		82899,
		82899
	],
	"./uk/gameReview.json": [
		7698,
		7698
	],
	"./uk/home.json": [
		58133,
		58133
	],
	"./uk/lobby.json": [
		15268,
		15268
	],
	"./uk/puzzles.json": [
		79673,
		79673
	],
	"./uz/analysis.json": [
		26614,
		26614
	],
	"./uz/auth.json": [
		12960,
		12960
	],
	"./uz/common.json": [
		76745,
		76745
	],
	"./uz/emailActivation.json": [
		98295,
		98295
	],
	"./uz/gameReview.json": [
		34640,
		34640
	],
	"./uz/home.json": [
		45966,
		51732
	],
	"./uz/lobby.json": [
		14059,
		14059
	],
	"./uz/puzzles.json": [
		13770,
		13770
	],
	"./vi/analysis.json": [
		14223,
		14223
	],
	"./vi/auth.json": [
		69339,
		69339
	],
	"./vi/common.json": [
		79789,
		79789
	],
	"./vi/emailActivation.json": [
		33321,
		33321
	],
	"./vi/gameReview.json": [
		8686,
		8686
	],
	"./vi/home.json": [
		94366,
		94366
	],
	"./vi/lobby.json": [
		90763,
		90763
	],
	"./vi/puzzles.json": [
		32287,
		32287
	],
	"./zh-CN/analysis.json": [
		56950,
		56950
	],
	"./zh-CN/auth.json": [
		24066,
		24066
	],
	"./zh-CN/common.json": [
		45807,
		45807
	],
	"./zh-CN/emailActivation.json": [
		86226,
		86226
	],
	"./zh-CN/gameReview.json": [
		38213,
		38213
	],
	"./zh-CN/home.json": [
		5520,
		5520
	],
	"./zh-CN/lobby.json": [
		44388,
		44388
	],
	"./zh-CN/puzzles.json": [
		92146,
		92146
	],
	"./zh-TW/analysis.json": [
		16320,
		16320
	],
	"./zh-TW/auth.json": [
		81274,
		81274
	],
	"./zh-TW/common.json": [
		47715,
		47715
	],
	"./zh-TW/emailActivation.json": [
		44860,
		44860
	],
	"./zh-TW/gameReview.json": [
		49413,
		49413
	],
	"./zh-TW/home.json": [
		54044,
		54044
	],
	"./zh-TW/lobby.json": [
		68145,
		68145
	],
	"./zh-TW/puzzles.json": [
		68630,
		68630
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 71539;
module.exports = webpackAsyncContext;